import { makeStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react'

import List from '@mui/material/List'

import MultiEntitySearch from './MultiEntitySearch'
import { Field } from 'formik'
import UserListItem from '../../2compounds/UserListItem'
import NamedListItem from '../../2compounds/NamedListItem'
import DecoratedListItem from '../../2compounds/DecoratedListItem'
import DecoratedListItemHeader from '../../2compounds/DecoratedListItemHeader'

import CollapseContainer from '../../2compounds/CollapseContainer'
import { Alert } from '@mui/material'

// the main control
const GenericInPlacePickList = ({
  selection,
  searchMoreCallback,
  searchNoSystem,
  pickerEntityDisplayName,
  listPropertyName,
  searchEntitySubType,
  deepSetSelection,
  formikProps,
  disabled,
  equalityEvaluator,
  listItemStyle,
  collapsableContentClassName,
  listItemConfig,
  superDisabled,
  isAddOnly,
  isReadOnly
}) => {
  const classes = useStyles()
  const [localSelection, setLocalSelection] = useState(selection)
  const [cacheListItemConfig, setCachedListItemConfig] = useState(null)

  useEffect(() => {
    if (listItemConfig) {
      setCachedListItemConfig(listItemConfig)
    }
  }, [listItemConfig])

  const compoundEqualityEvaluator = (a, b) => {
    if (equalityEvaluator) return equalityEvaluator(a, b)
    const equalityEvaluatorWithId = () => {
      return a.id === b.id
    }
    return equalityEvaluatorWithId()
  }
  const header = (
    <>
      Assigned {pickerEntityDisplayName}
      {/* <span className={'requiredAsterisk'}>{listPropertyName}</span> */}
    </>
  )

  const setLocalSelectionProxy = theSelection => {
    deepSetSelection(theSelection, formikProps)
    setLocalSelection(theSelection)
  }

  useEffect(() => {
    if (selection) {
      setLocalSelection(selection)
    }
  }, [selection])

  const renderListItem = (index, o, allowDelete = true) => {
    switch (listItemStyle) {
      case 'user':
        return (
          <UserListItem
            key={index}
            disabled={disabled}
            user={o}
            index={index}
            deleteHandler={allowDelete
              ? () => {
                  const everyoneExceptMe = localSelection.filter(one => !compoundEqualityEvaluator(one, o))
                  setLocalSelectionProxy(everyoneExceptMe)
                }
              : undefined}
          />
        )
      case 'decorated':
        return (
          <DecoratedListItem
            key={index}
            disabled={disabled}
            formikProps={formikProps}
            targetObject={o}
            index={index}
            deleteHandler={allowDelete
              ? () => {
                  const everyoneExceptMe = localSelection.filter(one => !compoundEqualityEvaluator(one, o))
                  setLocalSelectionProxy(everyoneExceptMe)
                }
              : undefined}
            itemConfig={cacheListItemConfig}
          />
        )
      default:
        return (
          <NamedListItem
            key={index}
            disabled={disabled}
            user={o}
            index={index}
            deleteHandler={allowDelete
              ? () => {
                  const everyoneExceptMe = localSelection.filter(one => !compoundEqualityEvaluator(one, o))
                  setLocalSelectionProxy(everyoneExceptMe)
                }
              : undefined}
          />
        )
    }
  }

  return (
    <Field name={listPropertyName} id={listPropertyName} type='hidden'>
      {({ field: { value } }) => (
        <div className={classes.root}>
          <CollapseContainer
            header={header}
            dataCount={localSelection.length}
            disabled={superDisabled}
          >
            {
            !disabled && !isReadOnly &&
              <>
                <MultiEntitySearch
                  searchMoreCallback={searchMoreCallback}
                  searchNoSystem={searchNoSystem}
                  searchEntitySubType={searchEntitySubType}
                  setSelection={theSelection => {
                    setLocalSelectionProxy(theSelection)
                  }}
                  isAddOnly={isAddOnly}
                  disabled={disabled}
                  selection={localSelection}
                  equalityEvaluator={compoundEqualityEvaluator}
                  className={collapsableContentClassName}
                />
                {listItemConfig?.titleArray && (
                  <div>
                    <DecoratedListItemHeader itemConfig={listItemConfig} />
                  </div>
                )}
              </>
          }
            {
            !disabled && isAddOnly &&
              <Alert severity='warning'>
                {listItemConfig?.restrictionMessage || <><strong>Restricted</strong> You can only add to this list.</>}
              </Alert>
          }
            <div>
              <List>
                {localSelection?.map((o, index) => renderListItem(index, o, !isReadOnly && !isAddOnly))}
              </List>
            </div>
          </CollapseContainer>
        </div>
      )}
    </Field>
  )
}

export default React.memo(GenericInPlacePickList)

const useStyles = makeStyles((theme, props) => ({
  root: {},
  errorMessageDiv: {
    margin: '0 14px'
  },
  autoComplete: {
    padding: 0,
    maxWidth: '400px',

    '& .MuiInputBase-root': {
      padding: 0
    },
    '& .MuiAutocomplete-inputRoot': {
      maxHeight: '29px'
    },
    '& .MuiInputBase-input': {
      height: '10px'
    }
  },

  deleteButton: {
    padding: '12px 0'
  }
}))
